export const CLEAR_ENTITY = 'CLEAR_ENTITY'
